export const startGermanLocalization = {
  routes: {
    'civil-protection_zero': 'Warnmeldungen',
    'civil-protection_other': '{{count}} Warnmeldungen',
    'civil-protection_one': 'Eine Warnmeldung'
  },
  screens: {
    start: {
      sections: {
        header: {
          subscribedGeoAreas_one: '+ ein Ort in Reichweite',
          subscribedGeoAreas_other: '+ {{count}} Orte in Reichweite',
          more: 'Mehr'
        },
        radio: {
          titleRecent: 'Aktuelles',
          titleCommunity: 'Aus der Funkgemeinde',
          to: 'Zur Funkzentrale',
          empty: {
            description: 'Es gibt noch keine Beiträge. \n Lass uns das ändern!',
            button: 'Jetzt mitfunken'
          },
          news: 'Neuste Meldungen',
          happenings: 'Event in deinem Ort',
          happeningsRegion: 'Event in deiner Region',
          happeningsEmpty: 'Noch keine Events in deinem Ort.',
          happeningsRegionEmpty: 'Noch keine Events in deiner Region.',
          happeningsError: 'Events konnten nicht geladen werden.',
          happeningsRegionError: 'Events konnten nicht geladen werden.',
          entries: 'Neues aus der Umgebung',
          groups: 'Neues aus Gruppen'
        },
        posts: {
          meinOrt: 'Aus deinem Ort',
          region: 'Aus deiner Region',
          empty: 'Noch keine Beiträge verfügbar.',
          error: 'Beiträge konnten nicht geladen werden.'
        },
        region: {
          title: 'Meine Region',
          to: 'Zur Region',
          empty: {
            description:
              'Noch keine regionalen Infos verfügbar.\nErfahre, wie deine Kommune das ändern kann',
            button: 'Mehr erfahren'
          },
          entries: 'Neueste Einträge',
          entertainment: 'Unterhaltung',
          volunteering: 'Ehrenamt',
          service: 'Dienste',
          focus: 'Im Fokus'
        },
        profile: {
          title: 'Mein Profil',
          to: 'Zum Profil',
          messages: 'Private Nachrichten',
          notifications: 'Benachrichtigungen verwalten',
          geoArea: 'Heimatort & Umkreis anpassen'
        }
      }
    }
  },
  components: {
    more: 'Alle',
    readMore: 'Mehr...',
    post: {
      blocked: 'Du hast diese Person blockiert.',
      delimiter: '・'
    },
    happening: {
      fullDay: 'Ganztägig',
      multiDay: '{{days}}-tägig',
      from: 'Ab {{day}}'
    },
    civilProtection: {
      title_other: '{{count}} Warnmeldungen',
      title_one: 'Eine Warnmeldung'
    },
    firstSteps: {
      title: 'So funktioniert die App',
      text: 'In zwei Minuten durch StadtLand.Funk: Wo du News, Gruppen und Infos aus deiner Kommune findest und wo die Partner deiner Region stehen. '
    },
    welcome: {
      title: 'Willkommen!',
      text: 'Schön, dass du da bist. Entdecke Neuigkeiten und Events aus deinem Ort und deiner Region.'
    },
    grussVomBuergerMeister: {
      title: 'Grußwort'
    },
    gemeinde: {
      defaultTitle: 'Ihre Gemeinde',
      defaultText:
        'Wichtige Informationen und Aktuelles aus Ihrer Gemeinde immer im Blick.'
    },
    newFeatures: {
      title: 'Neue Funktionen',
      text: 'Erfahre, welche neuen Funktionen verfügbar sind. Klicke einfach auf '
    }
  }
};

// Guarantees that both translations have the same structure
type StartLocales = typeof startGermanLocalization;

export const startEnglishLocalization: StartLocales = {
  routes: {
    'civil-protection_zero': 'Alerts',
    'civil-protection_other': '{{count}} Alerts',
    'civil-protection_one': 'One alert'
  },
  screens: {
    start: {
      sections: {
        header: {
          subscribedGeoAreas_one: '+ one community in range',
          subscribedGeoAreas_other: '+ {{count}} communities in range',
          more: 'More'
        },
        radio: {
          titleRecent: 'Recent',
          titleCommunity: 'From the Community',
          to: 'To the Local Hub',
          empty: {
            description: 'There are no posts yet. \n Let’s change that!',
            button: 'Post now'
          },
          news: 'Latest news',
          happenings: 'Event in your Community',
          happeningsRegion: 'Event in your Region',
          happeningsEmpty: 'No events in your community yet.',
          happeningsRegionEmpty: 'No events in your region yet.',
          happeningsError: 'Events could not be loaded.',
          happeningsRegionError: 'Events could not be loaded.',
          entries: 'Latest from the vicinity',
          groups: 'Latest from groups'
        },
        posts: {
          meinOrt: 'From your community',
          region: 'From your region',
          empty: 'No posts available yet.',
          error: 'Posts could not be loaded.'
        },
        region: {
          title: 'My Region',
          to: 'To the Region',
          empty: {
            description:
              'No regional information available yet.\nFind out how your municipality can change that',
            button: 'Learn more'
          },
          entries: 'Latest entries',
          entertainment: 'Entertainment',
          volunteering: 'Volunteering',
          service: 'Services',
          focus: 'In Focus'
        },
        profile: {
          title: 'My Profile',
          to: 'To the Profile',
          messages: 'Private messages',
          notifications: 'Manage Notifications',
          geoArea: 'Adjust Home area & Surroundings'
        }
      }
    }
  },
  components: {
    more: 'Show all',
    readMore: 'More...',
    post: {
      blocked: 'You have blocked this person.',
      delimiter: '・'
    },
    happening: {
      fullDay: 'All Day',
      multiDay: '{{days}}-day',
      from: 'From {{day}}'
    },
    civilProtection: {
      title_other: '{{count}} Alerts',
      title_one: 'One alert'
    },
    firstSteps: {
      title: 'How the app works',
      text: 'Two minutes through StadtLand.Funk: where to find news, groups and info from your municipality, and where the partners of your region are. '
    },
    welcome: {
      title: 'Welcome!',
      text: 'Great to have you here. Discover news and events from your community and your region.'
    },
    grussVomBuergerMeister: {
      title: 'Greeting'
    },
    gemeinde: {
      defaultTitle: 'Your Municipality',
      defaultText:
        'Important information and news from your municipality always at a glance.'
    },
    newFeatures: {
      title: 'New features',
      text: 'Discover the new features! Click on '
    }
  }
};
